import { InjectionToken } from '@angular/core';

/**
 * Interface für den OpenGraphService.
 * Setzt dynamische meta Tags nach dem Open Graph Protocol. Trägt zur besseren Darstellung beim Teilen in sozialen Netzewerken bei.
 * Muss per InjectionToken provided werden
 * https://ogp.me/
 *
 * Dieser Service wird in der SUCHE-App provided und somit können auch die Komponenten
 * aus der SUCHE-Lib darauf zugreifen.
 * In der Lib ist diese Dependency optional und muss daher nicht von SET-E provided werden.
 *
 * Diese Open Graph Daten werden also nur von in der SUCHE-Standalone-Anwendung bereitgestellt.
 *
 * Dieses Muster weicht vom bisherigem ab, bei dem wir Funktionalität über Feature-Toggles in der
 * Lib-Config für SET-E abschaltbar gemacht haben.
 */
export interface IOpenGraphService {
  setDescription(description: string): void;
}

export const OPEN_GRAPH_SERVICE: InjectionToken<IOpenGraphService> =
  new InjectionToken<IOpenGraphService>('OpenGraphService');
